"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeAMountArtNrGenerator = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
/**
 * The `DefaultAEArtNrGenerator` provides information to create the `AeArtNrModel` for unknown AE systems.
 */
class TypeAMountArtNrGenerator {
    generateAEArtNr(artNr, { material, color }) {
        const separator = echain_shared_i18n_1.LocaleService.getArtNrSeparator();
        const splitArtNrArr = artNr.split(separator);
        const splitArtNrArrInsertIndex = splitArtNrArr.length - 1;
        // Material is inserted first so the 'splitArtNrArrInsertIndex' stays the same.
        if (material) {
            splitArtNrArr.splice(splitArtNrArrInsertIndex, 0, material);
        }
        // black (0) should not be appended. [EKE-461]
        if (color && +color !== 0) {
            splitArtNrArr.splice(splitArtNrArrInsertIndex, 0, color);
        }
        return splitArtNrArr.join(separator);
    }
}
exports.TypeAMountArtNrGenerator = TypeAMountArtNrGenerator;
//# sourceMappingURL=TypeAMountArtNrGenerator.js.map